module.exports = __webpack_public_path__ + "static/media/blueTickIcon.55338a4c.svg";